<template>
  <div
    class="sc3-text-input chart-thumbnail-name"
    @click="handleTitleClicked()"
    v-show="!isInputFocused && !isReadOnly"
    v-sanitize-html="chartOrChartStyle.temporaryName"
  ></div>
  <input
    v-show="isInputFocused || isReadOnly"
    type="text"
    class="sc3-text-input chart-thumbnail-name"
    :class="{
      'sc3-text-input-invalid': !chartOrChartStyle.temporaryName.trim(),
      'sc3-text-input-readonly': isReadOnly
    }"
    :title="chartOrChartStyle.name"
    v-model="chartOrChartStyle.temporaryName"
    :placeholder="isChartStyleMode ? 'ChartStyle Name' : 'Chart Name'"
    @blur="handleInputBlurred()"
    @keyup.enter="handleInputSubmit()"
    autocomplete="off"
    :readonly="isReadOnly"
    ref="chartThumbnailNameInput"
  />
</template>

<script lang="ts" setup>
  // TODO: this component is only temporary until a more in-depth refactor of ChartLibraryMode can be done. This is necessary to be able to encapsulate the logic of the chart thumbnail name input DOM Element with the logic directly.
  import { ref, nextTick, toRefs } from 'vue';
  import { SimpleFrontendChart } from '@/interfaces/chart';
  import { SimpleFrontendChartStyle } from '@/interfaces/chartStyle';

  const props = defineProps<{
    chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle;
    isChartStyleMode: boolean;
    isReadOnly: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'inputBlur'): void;
  }>();

  const {
    chartOrChartStyle,
    isChartStyleMode,
    isReadOnly
  } = toRefs(props);

  const chartThumbnailNameInput = ref<HTMLInputElement>();
  const isInputFocused = ref(false);

  async function handleTitleClicked() {
    if (isReadOnly.value) {
      return;
    }
    isInputFocused.value = true;
    await nextTick();
    chartThumbnailNameInput.value?.focus({ preventScroll: true });
  }

  function handleInputBlurred() {
    isInputFocused.value = false;
    emit('inputBlur');
  }

  function handleInputSubmit() {
    chartThumbnailNameInput.value?.blur();
    isInputFocused.value = false;
  }
</script>

<style scoped>
  input[type=text].sc3-text-input.chart-thumbnail-name,
  div.sc3-text-input.chart-thumbnail-name {
    height: 22px;
    text-align: center;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1;
    padding: 0px 4px;
    margin: 0px 0px 4px 0px;
    color: #2d3339;
    z-index: 2;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  input[type=text].sc3-text-input.chart-thumbnail-name:not(:hover):not(:active):not(:focus),
  input[type=text].sc3-text-input.chart-thumbnail-name.sc3-text-input-readonly,
  div.sc3-text-input.chart-thumbnail-name:not(:hover):not(:active):not(:focus) {
    border-color: transparent;
    background-color: transparent;
  }
</style>
